<dx-scroll-view class="view-wrapper-scroll">
  <div class="view-wrapper">
    <toolbar-analytics
      titleText="Geography"
      [panelItems]="analyticsPanelItems"
      [selectedItems]="[5]"
      (selectionChanged)="selectionChange($event)"
    >
    </toolbar-analytics>

    <div class="cards wide">
      <sales-map-card [data]="salesByStateMarkers"></sales-map-card>
    </div>

    <div class="cards">
      <revenue-analysis-by-states-card [data]="salesByStateAndCity">
      </revenue-analysis-by-states-card>
      <revenue-snapshot-by-states-card [data]="salesByState">
      </revenue-snapshot-by-states-card>
    </div>
  </div>
</dx-scroll-view>
<dx-load-panel
  container=".view-wrapper"
  [position]="{ of: '.content' }"
  [visible]="isLoading"
  [showPane]="true"
></dx-load-panel>
